/// <reference path="../wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.WorkViewFilterList";
        class WorkViewFilterListWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("WorkViewFilterListWidgetTypeClass.createInstance()");
                    return new WorkViewFilterListWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("WorkViewFilterListWidgetTypeClass._storeHtml()");
                    WorkViewFilterListWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewFilterListWidgetTypeClass::constructor");
                if (WorkViewFilterListWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/WorkViewFilterList/workview-filterlist.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.WorkViewFilterListWidgetTypeClass = WorkViewFilterListWidgetTypeClass;
        class WorkViewFilterListWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._listHolder = null;
                this._dataList = null;
                this._viewConfigFile = null;
                this._presentAsButtons = null;
                this._buttonsVertical = null;
                this._buttonPalette = null;
                this._entryList = null;
                this.presentInstance = () => {
                    this._log.info("WorkViewFilterListWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = WorkViewFilterListWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._listHolder = this._container.querySelector('#workViewFilterListHolder');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#workViewFilterListWidgetTitle'), 'STR_WPT_FILTERLIST');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#workViewFilterListLoading'), 'STR_WPT_LOADING');
                    if (this._presentAsButtons && this._buttonsVertical) {
                        this._listHolder.classList.remove('widget__body-item--no-padding');
                    }
                    if (this._presentAsButtons) {
                        let usePrimary = false;
                        if (this._config.hasOwnProperty('SuppressHeading') && this._config.SuppressHeading === true) {
                            usePrimary = true;
                        }
                        let bpConfig = {
                            Orientation: this._buttonsVertical ? 'Vertical' : 'Horizontal',
                            SuppressNoItemsBanner: true,
                            UsePrimaryColour: usePrimary
                        };
                        this._buttonPalette = new Widgets.ComponentButtonPalette(this._core, this._listHolder, this, bpConfig, this._filterClicked);
                        this._buttonPalette.present();
                    }
                    else {
                        let listConfig = {
                            SelectItemCallback: this._filterClicked
                        };
                        this._dataList = new Widgets.ComponentDataList(this._core, this._listHolder, this, listConfig);
                        this._dataList.present();
                    }
                    this._core.Functions.showElement(this._loader);
                    let conf = this._config;
                    this._entryList = null;
                    if (conf.hasOwnProperty('Applications') && conf.Applications.length > 0) {
                        let applicationList = null;
                        if (conf.Applications[0].hasOwnProperty('ApplicationName')) {
                            this._entryList = conf.Applications;
                            applicationList = this._entryList.map(entry => entry.ApplicationName);
                        }
                        else {
                            applicationList = conf.Applications;
                        }
                        let requestApplications = {
                            Applications: applicationList
                        };
                        let request = JSON.stringify(requestApplications);
                        this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/GetAllFiltersForApplications', request, this._presentFilterList, null, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        this._core.Loader.genericServiceCall('/WorkView.svc/rest/GetAllFilters', this._presentFilterList, this._callErrorHandler, this._callFailedHandler);
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._presentFilterList = (filterData) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("WorkViewFilterListWidgetInstanceClass._presentFilterList()");
                    this._core.Functions.hideElement(this._loader);
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearDisplay();
                    }
                    else {
                        this._dataList.clearList();
                    }
                    let applications = filterData.Applications;
                    let applicationsLength = applications.length;
                    let entries = [];
                    for (let a = 0; a < applicationsLength; a++) {
                        let application = applications[a];
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`processing application '${application.Name}'`);
                        }
                        let appConfig = yield this._core.Helper.getWvViewConfigForApplication(this._viewConfigFile, application.Name);
                        let label = null;
                        let appConfigEntry = null;
                        if (this._entryList && this._entryList.length > 0) {
                            appConfigEntry = this._entryList.find(entry => entry.ApplicationName == application.Name);
                            if (appConfigEntry && appConfigEntry.hasOwnProperty('DisplayName') && appConfigEntry.DisplayName.length > 0) {
                                label = this._core.Locale.getTranslation(appConfigEntry.DisplayName);
                            }
                            if (appConfigEntry == null || appConfigEntry == undefined) {
                                console.warn(`Applications configured as entries, but application '${application.Name}' not found. Shouldn't happen.`);
                                continue;
                            }
                        }
                        if (label == null) {
                            if (appConfig && appConfig.hasOwnProperty('DisplayName') && appConfig.DisplayName.length > 0) {
                                label = this._core.Locale.getTranslation(appConfig.DisplayName);
                            }
                        }
                        if (label == null) {
                            label = application.Name;
                        }
                        let appEntry = {
                            ApplicationName: application.Name,
                            Id: application.Id.toString(10),
                            DisplayName: label,
                            Filters: []
                        };
                        let filtersAdded = false;
                        let filtersLength = application.Filters.length;
                        for (let f = 0; f < filtersLength; f++) {
                            let filter = application.Filters[f];
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`processing filter '${filter.Name}'`);
                            }
                            let filterConfig = null;
                            let label = null;
                            let icon = null;
                            let filterConfigEntry = null;
                            if (appConfig && appConfig.hasOwnProperty('Filters') && appConfig.Filters.length > 0) {
                                filterConfig = appConfig.Filters.find(f => f.Name == filter.Name);
                            }
                            if (appConfigEntry && appConfigEntry.Filters.length > 0) {
                                filterConfigEntry = appConfigEntry.Filters.find(entry => entry.FilterName == filter.Name);
                                if (filterConfigEntry && filterConfigEntry.hasOwnProperty('DisplayName') && filterConfigEntry.DisplayName.length > 0) {
                                    label = this._core.Locale.getTranslation(filterConfigEntry.DisplayName);
                                }
                                if (filterConfigEntry && filterConfigEntry.hasOwnProperty('Icon') && filterConfigEntry.Icon) {
                                    icon = filterConfigEntry.Icon;
                                }
                            }
                            if (appConfigEntry && (filterConfigEntry == null || filterConfigEntry == undefined)) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`filter '${filter.Name}' not in entry list, ignore...`);
                                }
                                continue;
                            }
                            if (label == null) {
                                if (filterConfig && filterConfig.hasOwnProperty('DisplayName') && filterConfig.DisplayName.length > 0) {
                                    label = this._core.Locale.getTranslation(filterConfig.DisplayName);
                                }
                            }
                            if (label == null) {
                                label = filter.Name;
                            }
                            let filterEntry = {
                                FilterName: filter.Name,
                                Id: application.Name + ":" + filter.Name,
                                DisplayName: label,
                                Icon: icon
                            };
                            appEntry.Filters.push(filterEntry);
                            if (!filtersAdded) {
                                filtersAdded = true;
                            }
                        }
                        if (filtersAdded) {
                            entries.push(appEntry);
                        }
                    }
                    this._presentFilterListData(entries);
                });
                this._presentFilterListData = (entries) => {
                    this._log.info("WorkViewFilterListWidgetInstanceClass._presentFilterListData()");
                    if (this._presentAsButtons) {
                        let buttonOptions = [];
                        entries.forEach(appEntry => {
                            appEntry.Filters.forEach(filterEntry => {
                                let buttonOption = {
                                    Identifier: filterEntry.Id,
                                    Label: filterEntry.DisplayName,
                                    Icon: filterEntry.Icon
                                };
                                buttonOptions.push(buttonOption);
                            });
                        });
                        this._buttonPalette.displayOptions(buttonOptions);
                    }
                    else {
                        let listData = {
                            Items: []
                        };
                        entries.forEach(appEntry => {
                            let appItem = {
                                Id: appEntry.Id,
                                DisplayName: appEntry.DisplayName,
                                Items: []
                            };
                            listData.Items.push(appItem);
                            appEntry.Filters.forEach(filterEntry => {
                                let filterItem = {
                                    Id: filterEntry.Id,
                                    DisplayName: filterEntry.DisplayName
                                };
                                appItem.Items.push(filterItem);
                            });
                        });
                        this._dataList.displayData(listData);
                    }
                };
                this._filterClicked = (id) => {
                    this._log.info("WorkViewFilterListWidgetInstanceClass._filterClicked()");
                    let splitPos = id.indexOf(":");
                    let appName = id.substring(0, splitPos);
                    let filterName = id.substring(splitPos + 1);
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearOptionSelection();
                        this._buttonPalette.selectOption(id);
                    }
                    else {
                        this._dataList.clearItemSelection();
                        this._dataList.selectItem(id);
                    }
                    let requestFilterResult = {
                        Application: appName,
                        Filter: filterName
                    };
                    let conf = this._config;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`clicked filter '${filterName}' of application '${appName}'`);
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_FILTER_SELECTED);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = requestFilterResult;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = this._currentLayout;
                    if (conf.hasOwnProperty("LaunchLayout") && conf.LaunchLayout) {
                        if (conf.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = conf.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (conf.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(conf.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("WorkViewFilterListWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("WorkViewFilterListWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewFilterListWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                if (conf.hasOwnProperty('ViewConfiguration') && conf.ViewConfiguration) {
                    this._viewConfigFile = conf.ViewConfiguration;
                }
                else {
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('WorkViewViewConfiguration') && appConfig.WorkViewViewConfiguration) {
                        this._viewConfigFile = appConfig.WorkViewViewConfiguration;
                    }
                }
                this._buttonsVertical = true;
                if (conf.hasOwnProperty('Type') && conf.Type === 'Buttons') {
                    this._presentAsButtons = true;
                    if (conf.hasOwnProperty('ButtonsVertical') && !conf.ButtonsVertical) {
                        this._buttonsVertical = false;
                    }
                }
                else {
                    this._presentAsButtons = false;
                }
            }
        }
        WorkViewFilterListWidgetInstanceClass.HtmlData = null;
        Widgets.WorkViewFilterListWidgetInstanceClass = WorkViewFilterListWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
